import React, { useState } from 'react';

export default function AdvancedDrawer({ children, title = "Advanced Filters" }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div>
            <div
                className="req-drawer-toggle"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span style={{ fontWeight: 500, color: 'var(--req-text)' }}>{title}</span>
                <span style={{ fontSize: '18px', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                    ▼
                </span>
            </div>
            <div className={`req-drawer-content ${isOpen ? 'open' : ''}`}>
                <div className="req-grid">
                    {children}
                </div>
            </div>
        </div>
    );
}
